export default "__VITE_ASSET__BCopgZUV__"